import Ajax from "../helpers/ajax";

export class Template 
{
    /**
     * Url-based cache of loaded templates.
     */
    protected static cache: {[key: string]: doT.RenderFunction} = {};

    public static load(url: string, skipCache: boolean = false): Promise<doT.RenderFunction>
    {
        return new Promise((resolve, reject) => 
        {
            if (skipCache || Template.cache[url] === undefined)
            {
                Ajax.get(url).then((result) =>
                {
                    let renderFunction = doT.template(result);
                    Template.cache[url] = renderFunction;
                    resolve(renderFunction);
                    
                }, reject);
            }
            else
            {
                return resolve(Template.cache[url]);
            }
        });
    }

    public static lazy(url: string, skipCache: boolean = false): LazyTemplate
    {
        return <LazyTemplate>() => 
        {
            return Template.load(url, skipCache);
        }
    }

    public static inline(templateString: string): LazyTemplate
    {
        const renderFunction = doT.template(templateString);
        return <LazyTemplate>() =>
        {
            return Promise.resolve(renderFunction);
        }
    }
}

export interface LazyTemplate
{
    (): Promise<doT.RenderFunction>;
}
